module.exports = __webpack_public_path__ + "img/auther.202c6aa9.png";